<template>
  <section style="">
    <div class="columns is-centered">
      <div
        class="column is-5-desktop is-8-tablet is-12-mobile content"
        style="z-index: 1;"
      >
        <div class="section">
          <div class="container">
            <b class="is-4 title is-pink">{{
              $t('Gracias por su información.')
            }}</b>
            <br />
            <b class>
              {{ $t('Verifique que los datos introducidos son correctos.') }}
            </b>
          </div>
          <hr />

          <b-loading
            :is-full-page="true"
            :active.sync="isLoading"
            :can-cancel="false"
          ></b-loading>
          <options-viewer :optionsObject="neofintechData.phase2" />
          <br />
          <div class="container" id="email">
            <p style="text-align: center;">
              <b-field grouped position="is-centered">
                <button @click="submitRequest" class="button is-primary">
                  {{ $t('Finalizar') }}
                </button>
              </b-field>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'
import EnumeratesFormater from '@/mixins/enumeratesFormater.js'
import OptionsViewer from '@/components/on-board/OptionsViewer.vue'
import SuccessModal from '@/components/on-board/SuccessModal'
export default {
  components: { OptionsViewer },
  mixins: [EnumeratesFormater, Fetcher],
  data() {
    return {}
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  },
  mounted() {
    try {
      const emptyFields = Object.values(this.neofintechData.phase2).filter(
        element => element && element.length == 0
      ).length
      if (emptyFields > 1) {
        this.$router.push({
          name: 'onBoard.neofintech.phase2.1'
        })
      }
    } catch (e) {
      this.$router.push({
        name: 'onBoard.neofintech.phase2.1'
      })
    }
  },
  methods: {
    ...mapActions('onBoard', ['putUpdateOnboardRequest']),
    submitRequest: function() {
      let self = this
      self.request(() =>
        self
          .putUpdateOnboardRequest({
            data: { phase2: self.neofintechData.phase2 },
            requestId: self.neofintechData.requestId
          })
          .then(function(response) {
            self.$dlg.modal(SuccessModal, {
              shaking: false,
              title: false,
              params: {
                title: self.$t('Gracias por su información'),
                bgColor: '#de4281',
                content: `<p>${self.$t(
                  'Para continuar, revise la bandeja de entrada de su email, le hemos enviado la evaluación.'
                )}</p>`,
                confirmText: self.$t('Aceptar')
              },
              callback: () => {
                self.$router.push({
                  name: 'onBoard.neofintech.phase2.status',
                  params: { id: response.GSI1SK }
                })
              }
            })
          })
      )
    }
  }
}
</script>
